import { SearchComponent } from '@/shared/ui/components';
import { SEARCH_BY_LIST } from '../../../config/waitingToReturnTab';
import { useWaitingToReturnSearch } from './useWaitingToReturnSearch';
import type { WaitingToReturnSearchProps } from './waitingToReturnSearch.types';

/**
 * Search bar of the waiting-to-return devices tab, letting the user look up returns by the configured search fields. Reads searchValue, searchByValue and the change handler from useWaitingToReturnSearch, renders a section title only when hasTitle is set, and passes a numeric input with a fixed dropdown width to the shared search component.
 *
 * @param hasTitle - Whether the 'Waiting for return devices' heading is shown.
 * @returns The search row markup.
 */
const WaitingToReturnSearch = ({ hasTitle }: WaitingToReturnSearchProps) => {
  const { searchValue, searchByValue, onChangeSearchComponent } = useWaitingToReturnSearch();

  return (
    <div className="return-search-row">
      {hasTitle && <div className="search-title">Waiting for return devices</div>}
      <SearchComponent
        searchValue={searchValue}
        options={SEARCH_BY_LIST}
        searchByValue={searchByValue}
        onChange={onChangeSearchComponent}
        dropdownWidth={122}
        inputType="number"
        dropdownStyle={{ minWidth: '124px' }}
        inputWidth={228}
        showSearch
      />
    </div>
  );
};

export default WaitingToReturnSearch;
